import { render } from "./FormPage.vue?vue&type=template&id=809767a6&ts=true"
import script from "./FormPage.vue?vue&type=script&lang=ts"
export * from "./FormPage.vue?vue&type=script&lang=ts"

import "./FormPage.vue?vue&type=style&index=0&id=809767a6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__